import { Fragment, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button, Input, Label, Table } from "reactstrap";
import { getAdminCompany, getAdminCompanyDevice } from "../../slices/admin/thunk";
import { useDispatch, useSelector } from "react-redux";
import CompanyDropdown from "./CompanyDropdownMenu";
import AdminDeviceRow from "./AdminDeviceRow";
import AdminDeviceModal from "./AdminDeviceModal";
import { getContractEndDate } from "../../helpers/data_conversion_helper";
import { SELECTION_ALL } from "../../common/constants";

function AdminDevice(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    document.title = t('PageMain.DocumentTitle');
    const device = useSelector(state => state.Admin.device);
    const companies = useSelector(state => state.Admin.company);
    const [searchWord, setSearchWord] = useState("");
    const [isShowModal, setShowModal] = useState(false);
    const [modalDevice, setModalDevice] = useState(null);
    const [isShowAll, setShowAll] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(props.selectedCompany);

    async function fetchData () {
        dispatch(getAdminCompany(false));
        dispatch(getAdminCompanyDevice(false, SELECTION_ALL));
    }

    useEffect(() => {
        fetchData();
        setSelectedCompany(props.selectedCompany);
    }, [props.selectedCompany])

    const handleSelect = (companyId) => {
        setSelectedCompany(companyId);
    };

    const handleCheckboxChange = (isChecked) => {
        setShowAll(isChecked);
    };
    
    return (
        <Fragment>
            <div className="d-flex flex-row align-items-start justify-content-between">
                <div className="d-flex flex-row align-items-start justify-content-start">
                    <Button size="sm" color="primary" className="mb-2 me-2" onClick={fetchData}>{t('Common.Btn.Refresh')}</Button>
                    <div className="mb-3">
                        <Input
                            name="searchWord"
                            className="form-control"
                            placeholder={t('Common.Btn.Search')}
                            type="text"
                            value={searchWord}
                            onChange={(event) => {
                                setSearchWord(event.target.value);
                            }}
                        />
                    </div>
                    <CompanyDropdown onChange={handleSelect} companyID={props.selectedCompany}/>
                     <div className="form-check ms-3 mt-1" >
                        <Input className="form-check-input" type="checkbox" checked={isShowAll} id="is-company-enabled-check"  onChange={(e) => handleCheckboxChange(e.target.checked)}/>
                        <Label className="form-check-label" htmlFor="is-company-enabled-check">{t('PageAdmin.Btn.DisplayDisabledDevice')}</Label>
                    </div>
                </div>
                <Button size="sm" color="secondary" className="mb-2 me-2" onClick={() => { setModalDevice(null); setShowModal(true); }}>{t('PageAdmin.Btn.CreateDevice')}</Button>
            </div>


            <div className="device-table" style={{ maxHeight: '100%', overflowY: 'auto' }}>
                <Table className="table-nowrap mb-3">
                    <thead className="table-light sticky-header">
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.ID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyTable.Name')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.SystemDeviceID')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.InstalledDate')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.UninstalledDate')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.ContractEndDate')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.Status')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.CreatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.LastUpdatedAt')}</th>
                            <th scope="col">{t('PageAdmin.CompanyDeviceTable.Action')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {companies.map(company => {
                            let scArray = device[company.id] || [];
                            return scArray
                                .filter(d => {
                                    if ((!isShowAll && !d.is_effective) || (selectedCompany !== SELECTION_ALL && selectedCompany !== null && d.admin_company_id !== selectedCompany)) return false;
                                    if (searchWord === "") return true;
                                    return (
                                       d.monitor_location_device_id !== null && d.monitor_location_device_id.toString().includes(searchWord) ||
                                        d.installation_date?.includes(searchWord) ||
                                        d.uninstallation_date?.includes(searchWord) ||
                                        getContractEndDate(d)?.includes(searchWord) ||
                                        d.toilet_height.includes(searchWord) ||
                                        d.opuschat_url.includes(searchWord) ||
                                        d.ai_version.includes(searchWord) ||
                                        d.remark.includes(searchWord)||
                                        company.name.includes(searchWord)
                                    );
                                })
                                .map(d => (
                                    <AdminDeviceRow
                                        data={d}
                                        key={d.id}
                                        companyName={company.name}
                                        onClickModify={() => {
                                            setModalDevice(d); setShowModal(true);
                                        }}
                                        onSelectedUpdateDevice={props.onSelectedUpdateDevice}
                                        onSelectedContractDevice={props.onSelectedContractDevice}
                                    />
                                ));
                        })}
                        
                    </tbody>
                </Table>
                <AdminDeviceModal show={isShowModal} onCloseClick={()=>{setShowModal(false)}} data={modalDevice} selectedCompany={selectedCompany}/>
            </div>
        </Fragment>
    );
}

export default AdminDevice;